import type { PlotMedia, PlottingContext } from "@pdfking/renderer-api"

import type { Guide, LazyPage, RequestMedia } from "#public"

import { SpreadSideAt } from "./PageBox"
import { PlotPage } from "./PlotPage"

// A single scroll unit: one page ("single") or a side-by-side spread ("cover"
// /"double"). Each page carries its own bleed + spacing margins in its SVG, so
// the group is just a flush flex row — the inner pages get their touching edge
// clamped (margin cut to a hard trim edge, no bleed across the spine) while the
// outer edges keep their margins. `start` gives the first page's global index
// so each PlotPage keeps a stable, page-numbered id for scroll/centre detection.
export function PlotGroup({
  active_guides,
  allow_selection,
  bleed,
  context,
  id,
  media_count,
  on_page_clicked,
  pages,
  printable,
  request_media,
  start,
  uuid,
}: {
  active_guides: Guide[]
  allow_selection: boolean
  bleed: boolean
  context: PlottingContext<unknown>
  id: string
  media_count: number
  on_page_clicked: ((info: { number: number; page: PlotMedia }) => void) | undefined
  pages: LazyPage[]
  printable: boolean
  request_media: RequestMedia | undefined
  start: number
  uuid: string
}) {
  return (
    <div className="flex flex-row items-center" id={id}>
      {pages.map((page, i) => (
        <PlotPage
          active_guides={active_guides as Guide[]}
          allow_selection={allow_selection}
          bleed={bleed}
          context={context}
          id={`${uuid}-${start + i}`}
          key={i}
          media_count={media_count}
          on_page_clicked={on_page_clicked}
          page={page}
          printable={printable}
          request_media={request_media}
          spread_side={SpreadSideAt(i, pages.length)}
          target="[data-ref=reader]"
        />
      ))}
    </div>
  )
}
